module.exports = __webpack_public_path__ + "img/login.eb458f73.png";